import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import workingOnIcon from '../../assets/advice-working-on.svg';

const InvalidAccount = () => {
  return (
    <div className="bg-white">
      <Container className="py-60">
        <Row className="ml-md-5">
          <Col md={12}>
            <h2 className="mb-4 text-center text-tangaroa ft-20">¡Lo sentimos!</h2>
            <h3 className="mb-4 text-center text-tangaroa ft-16">Parece que esta no es la cuenta con la que ganaste la Subasta Rewards, por favor inicia sesión con la cuenta correcta.</h3>
            <div className="text-center mb-15">
              <img alt="Ya tenemos tus datos" src={workingOnIcon} />
            </div>
            <p className="text-center mb-30 text-tangaroa ft-16 f-600">Haz clic en el botón para cerrar sesión.</p>
            <div className="text-center">
              <a type="button" href="/" className="btn btn-primary btn-size-override mb-15">Cerrar sesión</a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default InvalidAccount;
